import React from 'react';

export const CheckSquareFilledIcon = ({ width, height, fill, rest }) => {
  return (
    <svg
      viewBox='64 64 896 896'
      focusable='false'
      width={width}
      height={height}
      className='icon icon-check-square-filled'
      {...rest}
    >
      <path
        fill={fill}
        d='M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM695.5 365.7l-210.6 292a31.8 31.8 0 01-51.7 0L308.5 484.9c-3.8-5.3 0-12.7 6.5-12.7h46.9c10.2 0 19.9 4.9 25.9 13.3l71.2 98.8 157.2-218c6-8.3 15.6-13.3 25.9-13.3H689c6.5 0 10.3 7.4 6.5 12.7z'
      />
    </svg>
  );
};

CheckSquareFilledIcon.defaultProps = {
  width: 16,
  height: 16,
  fill: 'currentColor'
};
